module.exports = __webpack_public_path__ + "static/media/sf-test-1.fca22a6b.mp3";